import React, { Component } from 'react';
import logo from '../logo.svg';




class Footer extends Component {
	
  render() {
    return (
         	<footer className="footer">
        	    OpenFlix 2016
            </footer>
     );
  }
}

export default Footer;


/** WEBPACK FOOTER **
 ** ./src/components/Footer.js
 **/